import { useSyncExternalStore } from 'react';

let current: { pathname: string; id: string } | null = null;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const snapshot = () => current;
const serverSnapshot = () => null;

export function setGoodsListSpmGroup(pathname: string, id: string): () => void {
  const value = { pathname, id };
  current = value;
  listeners.forEach((listener) => listener());
  return () => {
    if (current === value) {
      current = null;
      listeners.forEach((listener) => listener());
    }
  };
}

export function useGoodsListSpmGroup(pathname: string | null): string | undefined {
  const group = useSyncExternalStore(subscribe, snapshot, serverSnapshot);
  return group && group.pathname === pathname ? group.id : undefined;
}
